import React from 'react';
import MenuContentHeader from './MenuContentHeader';
import MenuContentItems from './MenuContentItems';
import getDeviceType from '@utility/deviceType';

const MenuContent = () => {
  const { isSpeedOrderMode } = getDeviceType();
  return (
    <div
      className="row pl-3 pr-1 align-content-start"
      style={{
        flex: '0 0 62%',
        maxWidth: '62%',
        marginTop: isSpeedOrderMode && "39px",
      }}
    >
      <MenuContentHeader />
      <MenuContentItems />
    </div>
  );
};

export default MenuContent;
